import { configureStore } from '@reduxjs/toolkit';
import businessApi from 'store/apis/businessApi';
import businessListApi from 'store/apis/businessListApi';
import countryListApi from 'store/apis/countryListApi';
import stateListApi from 'store/apis/stateListApi';
import payoutApi from 'store/apis/payoutApi';
import imageUploadApi from 'store/apis/imageUploadApi';
import onboardingApi from 'store/apis/onboardingApi';
import communityListApi from 'store/apis/communityListApi';
import signUpApi from 'store/apis/signUpApi';
import countryExtensionApi from 'store/apis/countryExtensionApi';
import forgotPasswordApi from 'store/apis/forgotPasswordApi';
import categoryApi from 'store/apis/categoryApi';
import externalLinksApi from 'store/apis/externalLinksApi';
import employeeApi from 'store/apis/employeeApi';
import businessUsersApi from 'store/apis/businessUsersApi';

import payoutReducer from 'store/slices/payoutSlice';
import defaultAccountApi from 'store/apis/defaultAccountApi';
import userApi from 'store/apis/userApi';
import businessReducer from 'store/slices/businessSlice';
import stateReducer from 'store/slices/stateSlice';
import countriesReducer from 'store/slices/countrySlice';
import defaultAccountReducer from 'store/slices/defaultAccountSlice';
import topUpHistoryReducer from 'store/slices/topUpHistorySlice';
import cityListApi from 'store/apis/cityListApi';

export const store = configureStore({
  reducer: {
    businesses: businessReducer,
    states: stateReducer,
    countries: countriesReducer,
    defaultAccount: defaultAccountReducer,
    topUpHistory: topUpHistoryReducer,
    payout: payoutReducer,
    [defaultAccountApi.reducerPath]: defaultAccountApi.reducer,
    [businessListApi.reducerPath]: businessListApi.reducer,
    [countryListApi.reducerPath]: countryListApi.reducer,
    [stateListApi.reducerPath]: stateListApi.reducer,
    [cityListApi.reducerPath]: cityListApi.reducer,
    [communityListApi.reducerPath]: communityListApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [businessApi.reducerPath]: businessApi.reducer,
    [payoutApi.reducerPath]: payoutApi.reducer,
    [imageUploadApi.reducerPath]: imageUploadApi.reducer,
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    [signUpApi.reducerPath]: signUpApi.reducer,
    [countryExtensionApi.reducerPath]: countryExtensionApi.reducer,
    [forgotPasswordApi.reducerPath]: forgotPasswordApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [externalLinksApi.reducerPath]: externalLinksApi.reducer,
    [employeeApi.reducerPath]: employeeApi.reducer,
    [businessUsersApi.reducerPath]: businessUsersApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      defaultAccountApi.middleware,
      businessListApi.middleware,
      countryListApi.middleware,
      stateListApi.middleware,
      cityListApi.middleware,
      communityListApi.middleware,
      userApi.middleware,
      businessApi.middleware,
      payoutApi.middleware,
      imageUploadApi.middleware,
      onboardingApi.middleware,
      signUpApi.middleware,
      countryExtensionApi.middleware,
      forgotPasswordApi.middleware,
      categoryApi.middleware,
      externalLinksApi.middleware,
      employeeApi.middleware,
      businessUsersApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
